// Funções para formatação de data

export const formataStringYearMonthToBr = (data) => {
  // data vindo no formato: yyyy-MM
  if (!data || typeof data !== 'string') return ''

  const separador = data.includes('-') ? '-' : '/'
  const [parte1, parte2] = data.split(separador)
  return `${parte2}/${parte1}`
}

export const desabilitarDatasFuturas = (time) => {
  return time.getTime() > Date.now()
}



// WEBPACK FOOTER //
// ./src/libs/utils/functions/dataFormater.js